import validation from "../../services/validation";

const formValidation = new validation();

export default {
    actions: {
        push({ commit }, errors) {
            commit("SET_ERRORS", errors);
        },
        reset({ commit }) {
            commit("RESET_ERRORS");
        },
    },
    getters: {
        pull(state) {
            return state.errors;
        },
    },
    mutations: {
        RESET_ERRORS(state) {
            state.errors.empty();
        },
        SET_ERRORS(state, payload) {
            state.errors.setMessages(payload);
        },
    },
    namespaced: true,
    state: {
        errors: formValidation,
    },
};
